import {isValidPhoneNumber} from "../../components/PhoneField"
import {isValidEmailAddress} from "../../email"
import {PassengerFormData, PastPassenger} from "./types"
import {PassengerInput} from "../../graphql/queries"
import {BookingFormPassengerState} from "../../state"

export function emptyPassenger(): PassengerFormData {
  return {
    id: null,
    name: "",
    email: "",
    mobile: "",
    phone: "",
  }
}

export function isValidPassenger(passenger: PassengerFormData, isAdmin: boolean) {
  return passengerErrorFields(passenger, isAdmin).size === 0
}

type PassengerFields = "name" | "mobile" | "phone" | "email"

export function passengerErrorFields(
  passenger: PassengerFormData,
  mobileRequired: boolean,
): Set<PassengerFields> {
  const fields = new Set<PassengerFields>()
  if (passenger.name === "") {
    fields.add("name")
  }
  if (mobileRequired && !passenger.mobile) {
    fields.add("mobile")
  }
  if (passenger.mobile && !isValidPhoneNumber(passenger.mobile)) {
    fields.add("mobile")
  }
  if (passenger.email && !isValidEmailAddress(passenger.email)) {
    fields.add("email")
  }
  if (passenger.phone && !isValidPhoneNumber(passenger.phone)) {
    fields.add("phone")
  }
  return fields
}

export function passengerToInput(p: BookingFormPassengerState): PassengerInput {
  return {
    id: p.id,
    name: p.name,
    // Empty string (from form field) becomes null
    mobile: p.mobile ? p.mobile : null,
    email: p.email ? p.email : null,
    phone: p.phone ? p.phone : null,
  }
}

export function passengersToInputPassengers(
  passengers: Array<BookingFormPassengerState>,
): Array<PassengerInput> {
  return passengers.map(passengerToInput)
}

export function pastPassengerToPassenger(pp: PastPassenger): PassengerFormData {
  return {
    id: null,
    name: pp.name,
    email: pp.email,
    mobile: pp.mobile,
    phone: pp.phone,
  }
}



// WEBPACK FOOTER //
// ./src/model/passenger/passenger.ts